import { render } from "./FormDropdown.vue?vue&type=template&id=995aa184&ts=true"
import script from "./FormDropdown.vue?vue&type=script&lang=ts"
export * from "./FormDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__